var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoArrowOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4 8.2",
    style: {
      enableBackground: "new 0 0 4 8.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFA93C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ff594a05-d857-4b4a-81e0-23eddb484505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e225d4f2-4027-4dc6-a8de-be58a8ead904"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,2.8c0.5,0,0.7-0.3,0.4-0.7L2.5,0.3C2.3,0,1.9-0.1,1.7,0.1c-0.1,0-0.1,0.1-0.2,0.2L0.1,2.1 C-0.1,2.5,0,2.8,0.5,2.8H3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.5,5.4C0,5.4-0.1,5.7,0.1,6.1L1.5,8c0.3,0.3,0.7,0.3,1,0c0,0,0,0,0,0l1.4-1.9C4.2,5.7,4,5.4,3.5,5.4H0.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowOrange);
export default __webpack_public_path__ + "media/ico-arrow-orange.b1d3f05bdd766adc518a5d576c45f1b5.svg";
export { ForwardRef as ReactComponent };